// extracted by mini-css-extract-plugin
export default {"ledyellow":"AppView_ledyellow__WINjS","blinkYellow":"AppView_blinkYellow__I2CU4","ledblue":"AppView_ledblue__RD2lD","blinkblue":"AppView_blinkblue__LKnRS"};